import { gql } from "apollo-boost";

export const gerenciarSalasListQuery = gql`
query gerenciarSalasListQuery ( $arquivado: Boolean ) {
  salaList ( archived: $arquivado ) {
    id
    maximo_participantes
    nome
  }
}`;

export const gerenciarSalasListForEnumQuery = gql`
query gerenciarSalasListQuery ( $arquivado: Boolean ) {
  gerenciarSalasList ( archived: $arquivado ) {
    id
    maximo_participantes
    nome
  }
}`;

export const gerenciarSalasArquivarMutation = gql`
  mutation gerenciarSalasArquivar($id: Int) {
    salaArchive(id: $id) {
      id
    }
  }
`;

export const gerenciarSalasRestaurarMutation = gql`
  mutation gerenciarSalasRestaurar($id: Int) {
    salaRestore(id: $id) {
      id
    }
  }
`;

export const gerenciarSalasOne = gql`
  query gerenciarSalasOne($id: Int) {
    salaOne(id: $id) {
      id
      nome
      maximo_participantes
    }
  }
`;

export const gerenciarSalasSave = gql`
  mutation gerenciarSalasSave($input: SalaInput!) {
    salaSave(input: $input) {
      id
    }
  }
`;